import { Paso } from "../types/paso";

/** Ordena los pasos según el flujo del proceso: prerrequisitos primero (por profundidad). */
export function ordenarPasosPorFlujo(pasos: Paso[]): Paso[] {
  const porId = new Map(pasos.map((p) => [p.id, p]));
  const cache = new Map<number, number>();
  const profundidad = (p: Paso, visto = new Set<number>()): number => {
    if (cache.has(p.id)) return cache.get(p.id)!;
    if (visto.has(p.id)) return 0; // ciclo (no debería ocurrir)
    visto.add(p.id);
    const d =
      p.depende_de.length === 0
        ? 0
        : 1 + Math.max(...p.depende_de.map((r) => (porId.has(r.id) ? profundidad(porId.get(r.id)!, visto) : 0)));
    cache.set(p.id, d);
    return d;
  };
  return [...pasos].sort((a, b) => profundidad(a) - profundidad(b) || a.nombre.localeCompare(b.nombre));
}
